import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:"/sistema/catalogos/precios",documento:'catalogs',acceso:'sesion',filas:['059'],cita:'Areas/Catalogs/Controllers/PricesController.cs:39'} satisfies RutaProd;
